/**
 * Created by lari on 17/04/2017.
 */
(function () {
  'use strict';
  angular.module('vcfinance.rksv')
    .component('deplist', {
      restrict: 'E',
      templateUrl: 'vcfinance/rksv/deplist-component.tpl.html',
      controllerAs: 'vm',
      controller: ['$log', 'Deplist', 'vertxEventBusService',
        function ($log, Deplist, vertxEventBusService) {
          let vm = this;
          vm.currentPage = 1;
          vm.pageChanged = pageChanged;
  
  
          this.$onInit = function () {
            let search = {};
  
            search.page = vm.currentpage;
            search.query = {};
  
            search.options = {};
            search.options.fields = {
              _id: 1,
              created: 1,
              receiptnr: 1,
              type: 1,
              signatureok: 1,
              pdfid: 1,
              storno: 1
            };
  
            vm.dep = Deplist.$search(search).$then(function (dep) {
              vm.totalItems = dep.$pageCount;
            });
          };
          
          function pageChanged() {
            vm.dep.$refresh({page: vm.currentPage}).$then(function (dep) {
              vm.totalItems = dep.$pageCount;
            });
          }


          vertxEventBusService.on('rksvdep.update', function (message) {
            $log.debug('debug: RKSV DEP update received: ', message);
            let messages = message.split(':');
            vm.dep.$refresh().$then(function () {
            }, function (error) {
            });
          });




        }] // controller
    }); // component

// klammerfriedhof
}());